import cn from "@utils/cn";
import { FC } from "react";

import { BentoBlockProps, BentoElementType, BentoTextElement, EditorialModuleImage } from "@/types";

import TiledBlockH1 from "./TiledBlockH1";
import TiledBlockHWithImage from "./TiledBlockHWithImage";
import TiledBlockV3 from "./TiledBlockV3";
import TiledBlockV4 from "./TiledBlockV4";
import TiledBlockVWithImage from "./TiledBlockVWithImage";

const BentoBlock: FC<BentoBlockProps> = ({ key, block }) => {
  let imageCounter = 0;
  let textCounter = 0;
  block.elements.forEach((element) => {
    switch (element.type) {
      case "editorialModuleImage": {
        imageCounter++;
        break;
      }
      case "bentoTextElement": {
        textCounter++;
        break;
      }
    }
  });

  let blockTag;
  if (imageCounter === 0 && textCounter === 4) {
    blockTag = <TiledBlockH1 items={block.elements as BentoTextElement[]} />;
  } else if (imageCounter === 1 && textCounter === 0) {
    blockTag = <TiledBlockV4 items={block.elements as EditorialModuleImage[]} />;
  } else if (imageCounter === 1 && textCounter === 3) {
    blockTag = <TiledBlockV3 items={block.elements} />;
  } else if (block.layout === "Horizontal" && block.elements.length === 3 && block.elements[1].type !== BentoElementType.image) {
    blockTag = <TiledBlockHWithImage items={block.elements} />;
  } else if (block.layout === "Vertical") {
    if (imageCounter === 1 && textCounter === 2) {
      blockTag = <TiledBlockVWithImage items={block.elements} />;
    }
  }

  if (blockTag) {
    return <div className={"group relative overflow-hidden w-[135dvw] md:w-[41.4dvw]"}>{blockTag}</div>;
  }
};

export default BentoBlock;
